export default "__VITE_ASSET__Ciz3QnUy__"